import { useContext, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from 'react-router-dom'
import { faMessage, faCheckCircle, faCircle  } from "@fortawesome/free-regular-svg-icons"

import { ApplicationContext } from 'context'

import ButtonPrimary from "components/ButtonPrimary"
import Chat from 'components/Chat'
import { Drawer, Badge } from 'antd'

import styles from "./styles.module.scss"
import { faSquareInfo, faTimer } from "@fortawesome/pro-solid-svg-icons";
import { faAngleDoubleRight, faCloudArrowUp, faFileContract, faSignature, faUsers } from "@fortawesome/free-solid-svg-icons";
// import { getSuretyLogo } from "lib/utils"

const OnBoardingDashboard = ({ requirements, surety }) => {
  const { contextAgency, contextError, contextLoading } = useContext(ApplicationContext)
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [_, setError] = contextError // eslint-disable-line
  const [agency] = contextAgency // eslint-disable-line

  const [open, setOpen] = useState(false)
  const [drawerType, setDrawerType] = useState('NOTES')

  const navigate = useNavigate()

  const _getStep = (text, isActive, isComplete) => {
    let classes = styles.onboarding__progress__step
    if (isComplete) {
      classes += ` ${styles.onboarding__progress__step__complete}`
    } else if (isActive) {
      classes += ` ${styles.onboarding__progress__step__active}`
    }
    return (
      <div className={classes}>
        <p>{text}</p>
        <span>
          {requirements.isInformationComplete && <FontAwesomeIcon icon={faCheckCircle} />}
          {!requirements.isInformationComplete && <FontAwesomeIcon icon={faCircle} />}
        </span>
      </div>
    )
  }

  const _getPodStatus = (isActive, isComplete) => {
    let classes = styles.onboarding__pod__container
    if (isComplete) {
      classes += ` ${styles.onboarding__pod__container__complete}`
    } else if (isActive) {
      classes += ` ${styles.onboarding__pod__container__active}`
    }
    return classes
  }

  let isCompleted = []
  let activeArea = 'INFORMATION'
  if (requirements.isInformationComplete) {
    activeArea = 'UPLOADS'
    isCompleted.push('INFORMATION')
    if (requirements.isUploadsComplete) {
      activeArea = 'FORMS'
      isCompleted.push('UPLOADS')
      if (requirements.isFilesSigned) {
        activeArea = 'REVIEW'
        isCompleted.push('FORMS')
        if (requirements.isApplicationReviewed) {
          activeArea = 'CONTRACT'
          isCompleted.push('REVIEW')
          if (requirements.isContractsSigned) {
            activeArea = 'FINAL_APPROVAL'
            isCompleted.push('CONTRACT')
          }
        }
      }
    }
  }

  
  const _handleDrawer = (type) => {
    setDrawerType(type)
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }
  
  return (
    <div className={styles.onboarding__container}>
      <div className={styles.onboarding__steps}>
        <header>
          <h2>Welcome to FCS Jeffrey!</h2>
          <p>To get started...</p>
        </header>
        <div className={_getPodStatus((activeArea === 'INFORMATION'), isCompleted.includes('INFORMATION'))}>
          <div className={styles.onboarding__pod}>
            <div className={styles.onboarding__pod__left}>
              <h4>Information</h4>
              <p>You have {requirements.sections.length} Sections to fill out.</p>
              <FontAwesomeIcon icon={faSquareInfo} />
            </div>
            <div className={styles.onboarding__pod__right}>
              {(activeArea === 'INFORMATION') && <ButtonPrimary color="navy" icon={faAngleDoubleRight} onClick={() => navigate(`/onboarding/information`)} isIconRightSide>Enter Information</ButtonPrimary>}
            </div>
          </div>
        </div>
        <div className={_getPodStatus((activeArea === 'UPLOADS'), isCompleted.includes('UPLOADS'))}>
          <div className={styles.onboarding__pod}>
            <div className={styles.onboarding__pod__left}>
              <h4>Uploads</h4>
              <p>You have {requirements.uploads.length} Uploads to send us.</p>
              <FontAwesomeIcon icon={faCloudArrowUp} />
            </div>
            <div className={styles.onboarding__pod__right}>
              {(activeArea === 'UPLOADS') && <ButtonPrimary color="navy" icon={faAngleDoubleRight} onClick={() => navigate(`/onboarding/uploads`)} isIconRightSide>Upload</ButtonPrimary>}
            </div>
          </div>
        </div>
        <div className={_getPodStatus((activeArea === 'FORMS'), isCompleted.includes('FORMS'))}>
          <div className={styles.onboarding__pod}>
            <div className={styles.onboarding__pod__left}>
              <h4>Sign your Application</h4>
              <p>You have {requirements.files.length} Forms to sign.</p>
              <FontAwesomeIcon icon={faSignature} />
            </div>
            <div className={styles.onboarding__pod__right}>
              {(activeArea === 'FORMS') && <ButtonPrimary color="navy" icon={faAngleDoubleRight} onClick={() => navigate(`/onboarding/sign`)} isIconRightSide>Sign your Application</ButtonPrimary>}
            </div>
          </div>
        </div>
        <div className={_getPodStatus((activeArea === 'REVIEW'), isCompleted.includes('REVIEW'))}>
          <div className={styles.onboarding__pod}>
            <div className={styles.onboarding__pod__left}>
              <h4>Application in Review</h4>
              <p>At this point you have done what you need to.  The application is now in review, and you will receive a notification once your contact is ready to sign.</p>
              <FontAwesomeIcon icon={faTimer} />
            </div>
            <div className={styles.onboarding__pod__right}>
              &nbsp;
            </div>
          </div>
        </div>
        <div className={_getPodStatus((activeArea === 'CONTRACT'), isCompleted.includes('CONTRACT'))}>
          <div className={styles.onboarding__pod}>
            <div className={styles.onboarding__pod__left}>
              <h4>Contract</h4>
              <p>It's time to sign your contract. After this we will get your License setup and you can begin to start onboaarding agencts..</p>
              <FontAwesomeIcon icon={faFileContract} />
            </div>
            <div className={styles.onboarding__pod__right}>
              {(activeArea === 'CONTRACT') && <ButtonPrimary color="navy" icon={faAngleDoubleRight} onClick={() => navigate(`/onboarding/sign/contract`)} isIconRightSide>Sign your Contract</ButtonPrimary>}
            </div>
          </div>
        </div>
        <div className={_getPodStatus((activeArea === 'FINAL_APPROVAL'), isCompleted.includes('FINAL_APPROVAL'))}>
          <div className={styles.onboarding__pod}>
            <div className={styles.onboarding__pod__left}>
              <h4>Final Approval</h4>
              <p>We are finalizing a few things on our side. You will receive a notification once your portal opens up.</p>
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className={styles.onboarding__pod__right}>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
      <div className={styles.onboarding__progress}>
        <div className={styles.onboarding__progress__images}>
          {/* {getSuretyLogo(report?.suretyId, report?.suretyName)} */}
        </div>
        <div className={styles.toolbar}>
          <Badge count=" " onClick={()=> _handleDrawer('CHAT')} size="default">
            <ButtonPrimary icon={faMessage}>
              Chat
            </ButtonPrimary>
          </Badge>
        </div>
        <div className={styles.onboarding__progress__steps}>
          {_getStep('1. Information', activeArea === 'INFORMATION', isCompleted.includes('INFORMATION'))}
          {_getStep('1. Uploads', activeArea === 'UPLOADS', isCompleted.includes('UPLOADS'))}
          {_getStep('3. Sign your Application', activeArea === 'FORMS', isCompleted.includes('FORMS'))}
          {_getStep('4. Review', activeArea === 'REVIEW', isCompleted.includes('REVIEW'))}
          {_getStep('5. Contract', activeArea === 'CONTRACT', isCompleted.includes('CONTRACT'))}
          {_getStep('6. Final Approval', activeArea === 'FINAL_APPROVAL', isCompleted.includes('FINAL_APPROVAL'))}
        </div>
      </div>

      <Drawer title={drawerType} onClose={onClose} open={open} mask={false} width="500px">
        {drawerType === 'CHAT' && <Chat agency={agency} surety={surety}/>}
      </Drawer>
    </div>
  )
}

export default OnBoardingDashboard
